<div class="container-fluid p-v-20 h-100 bg-white">
    <div class="d-flex flex-column justify-content-between h-100">
        <div class=" d-md-block p-h-40 text-center">
<!--            <img class="img-fluid" alt="" src="assets/images/logo/logohtnm.jpg">-->
        </div>
        <div class="container">
            <div class="row align-items-center">
                <div class="col-md-5">
                    <div class="p-v-30">
                        <h1 class="font-weight-semibold display-1 text-primary lh-1-2">{{ERROR_PAGES[code].code}}</h1>
                        <h2 class="font-weight-light font-size-30">{{ERROR_PAGES[code].message}}</h2>
                        <p class="lead m-b-30">{{ERROR_PAGES[code].subMessage}}</p>
                        <a nz-button nzType="primary" routerLink="/" nz-button nzType="primary">Quay lại trang chủ</a>
                    </div>
                </div>
                <div class="col-md-6 m-l-auto">
                    <img class="img-fluid" src="assets/images/others/error-1.png" alt="">
                </div>
            </div>
        </div>
        <div class=" d-md-flex p-h-40 justify-content-between">
            <span class=""></span>
            <ul class="list-inline">
                <li class="list-inline-item">
                    <a class="text-dark text-link" href="">Legal</a>
                </li>
                <li class="list-inline-item">
                    <a class="text-dark text-link" href="">Privacy</a>
                </li>
            </ul>
        </div>
    </div>
</div>
